export enum SelectToolEventType {
  FeatureSelected = 'featureSelected',
  FeatureDeselected = 'featureDeselected',
}
